module.exports = __webpack_public_path__ + "static/media/transformate6.2e208282.jpg";